/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {EArgosReportsState} from "../../../../../constants/colors"
import {
  IGeneralErrorDialogErrorObject
} from "../../../SensingSystemArchitectureDesign/ViewStudy/ExperimentsPanel/BillOfMaterialsSection/Dialogs/ViewDataSetErrorDialog/GeneralErrorDialog";


export const enum AdasProgramsReportPages {
  SENSING_SYSTEM_REQUIREMENT = 'sensingSystemRequirement',
  SENSOR_COMPONENT_REQUIREMENT = 'sensorComponentRequirement',
  WORLD_MODEL_SOLUTION_REQUIREMENT = 'worldModelSolutionRequirement',
}

/** Name to display in horizontal tabs component */
export const SENSOR_COMPONENT_REQUIREMENTS_NAME = 'Sensor Component Requirements'
/** Name to display in horizontal tabs component */
export const SENSING_SYSTEM_REQUIREMENTS_NAME = 'Sensing System Requirements'
/** Name to display in horizontal tabs component */
export const WORLD_MODEL_SOLUTION_REQUIREMENTS_NAME = 'World Model Solution Requirements'
export const ADAS_PROGRAMS_REPORT_PAGE_NAME_MAP: Record<AdasProgramsReportPages, string> = {
  [AdasProgramsReportPages.SENSING_SYSTEM_REQUIREMENT]: SENSING_SYSTEM_REQUIREMENTS_NAME,
  [AdasProgramsReportPages.SENSOR_COMPONENT_REQUIREMENT]: SENSOR_COMPONENT_REQUIREMENTS_NAME,
  [AdasProgramsReportPages.WORLD_MODEL_SOLUTION_REQUIREMENT]: WORLD_MODEL_SOLUTION_REQUIREMENTS_NAME,
}

export const enum AdasProgramsReportPageIdx {
  SENSING_SYSTEM_REQUIREMENT = '1',
  SENSOR_COMPONENT_REQUIREMENT = '2',
  WORLD_MODEL_SOLUTION_REQUIREMENT = '3',
}

export const pageToHtabIndexMap: Record<string, AdasProgramsReportPageIdx> = {
  [AdasProgramsReportPages.SENSING_SYSTEM_REQUIREMENT]: AdasProgramsReportPageIdx.SENSING_SYSTEM_REQUIREMENT,
  [AdasProgramsReportPages.SENSOR_COMPONENT_REQUIREMENT]: AdasProgramsReportPageIdx.SENSOR_COMPONENT_REQUIREMENT,
  [AdasProgramsReportPages.WORLD_MODEL_SOLUTION_REQUIREMENT]: AdasProgramsReportPageIdx.WORLD_MODEL_SOLUTION_REQUIREMENT,
}

export const htabIndexToPageMap: Record<string, AdasProgramsReportPages> = {
  [AdasProgramsReportPageIdx.SENSING_SYSTEM_REQUIREMENT]: AdasProgramsReportPages.SENSING_SYSTEM_REQUIREMENT,
  [AdasProgramsReportPageIdx.SENSOR_COMPONENT_REQUIREMENT]: AdasProgramsReportPages.SENSOR_COMPONENT_REQUIREMENT,
  [AdasProgramsReportPageIdx.WORLD_MODEL_SOLUTION_REQUIREMENT]: AdasProgramsReportPages.WORLD_MODEL_SOLUTION_REQUIREMENT,
}

export const enum VehicleProgramsReportPages {
  SENSING_SYSTEM_PERFORMANCE = 'sensingSystemPerformance',
}

export const enum ReportPages {
  SENSING_SYSTEM_REQUIREMENT = AdasProgramsReportPages.SENSING_SYSTEM_REQUIREMENT,
  SENSOR_COMPONENT_REQUIREMENT = AdasProgramsReportPages.SENSOR_COMPONENT_REQUIREMENT,
  WORLD_MODEL_SOLUTION_REQUIREMENT = AdasProgramsReportPages.WORLD_MODEL_SOLUTION_REQUIREMENT,
  SENSING_SYSTEM_PERFORMANCE = VehicleProgramsReportPages.SENSING_SYSTEM_PERFORMANCE,
}

export const enum EUpdateReportsStatus {
  NOT_STARTED = 'notStarted',
  IN_PROGRESS = 'inProgress',
  SUCCESS = 'success',
  FAILED = 'failed',
}

export type BaseReportsTableData = {
  reportId: string
  reportName: string
  dataSetState: EArgosReportsState
  requirement: string
  reportFormat: string
  comments: string
  error?: IGeneralErrorDialogErrorObject
}

export type RedLineReportsTableData = {
  coverageAnalysisStudyId: string
  redLineDataSetId: string
  redLineDataSetName: string
  redLineDataSetMergeConfiguration: string
}

export type GreenLineReportsTableData = {
  sensingArchitectureStudyId: string
  greenLineDataSetId: string
  greenLineDataSetName: string
  sensorId: string
  sensorName: string
  sensorLocation: string
  sensorModality: string
  sensorNameModality?: string
}

export type ReportsTableData = BaseReportsTableData & (RedLineReportsTableData | GreenLineReportsTableData)
